export default [
  {
    path: "/lucky-winner/campaign/list",
    name: "lucky-winner-campaign-list",
    component: () =>
      import(
        "@/views/pages/lucky-winner/campaign/campaign-list/CampaignList.vue"
      ),
    meta: {},
    breadcrumb: [
      {
        text: "Lucky Winner",
        to: "/lucky-winner/campaign/list",
      },
      {
        text: "Campaign List",
        active: true,
      },
    ],
  },
  {
    path: "/lucky-winner/campaign/create",
    name: "lucky-winner-campaign-create",
    component: () =>
      import(
        "@/views/pages/lucky-winner/campaign/campaign-info/CampaignInfo.vue"
      ),
    meta: {},
    breadcrumb: [
      {
        text: "Lucky Winner",
        to: "/lucky-winner/campaign/list",
      },
      {
        text: "Add Campaign",
        active: true,
      },
    ],
  },
  {
    path: "/lucky-winner/campaign/info/:campaignId",
    name: "lucky-winner-campaign-info",
    component: () =>
      import(
        "@/views/pages/lucky-winner/campaign/campaign-info/CampaignInfo.vue"
      ),
    meta: {},
    breadcrumb: [
      {
        text: "Lucky Winner",
        to: "/lucky-winner/campaign/list",
      },
      {
        text: "Edit Campaign",
        active: true,
      },
    ],
  },
  {
    path: "/lucky-winner/campaign/:campaignId/round/list",
    name: "lucky-winner-round-list",
    component: () =>
      import("@/views/pages/lucky-winner/round/round-list/RoundList.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Lucky Winner",
        to: "/lucky-winner/campaign/list",
      },
      {
        text: "Round List",
        active: true,
      },
    ],
  },
  {
    path: "/lucky-winner/campaign/:campaignId/round/create",
    name: "lucky-winner-round-create",
    component: () =>
      import("@/views/pages/lucky-winner/round/round-info/RoundInfo.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Lucky Winner",
        to: "/lucky-winner/campaign/list",
      },
      {
        text: "Add Round",
        active: true,
      },
    ],
  },
  {
    path: "/lucky-winner/campaign/:campaignId/round/info/:roundId",
    name: "lucky-winner-round-info",
    component: () =>
      import("@/views/pages/lucky-winner/round/round-info/RoundInfo.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Lucky Winner",
        to: "/lucky-winner/campaign/list",
      },
      {
        text: "Edit Round",
        active: true,
      },
    ],
  },
  {
    path: "/lucky-winner/campaign/:campaignId/round/:roundId/reward/list",
    name: "lucky-winner-reward-list",
    component: () =>
      import("@/views/pages/lucky-winner/reward/reward-list/RewardList.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Lucky Winner",
        to: "/lucky-winner/campaign/list",
      },
      {
        text: "Reward List",
        active: true,
      },
    ],
  },
  {
    path: "/lucky-winner/campaign/:campaignId/round/:roundId/reward/create",
    name: "lucky-winner-reward-create",
    component: () =>
      import("@/views/pages/lucky-winner/reward/reward-info/RewardInfo.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Lucky Winner",
        to: "/lucky-winner/campaign/list",
      },
      {
        text: "Add Reward",
        active: true,
      },
    ],
  },
  {
    path: "/lucky-winner/campaign/:campaignId/round/:roundId/reward/info/:rewardId",
    name: "lucky-winner-reward-info",
    component: () =>
      import("@/views/pages/lucky-winner/reward/reward-info/RewardInfo.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Lucky Winner",
        to: "/lucky-winner/campaign/list",
      },
      {
        text: "Edit Reward",
        active: true,
      },
    ],
  },
]
